import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';

@Component({
  selector: 'app-copy-value',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span class="inline-flex items-center gap-1 max-w-full min-w-0">
      <span class="font-mono text-xs truncate min-w-0" [title]="display ?? value ?? ''">{{ display ?? value }}</span>
      <button type="button"
              class="inline-flex items-center bg-transparent border-0 p-0 cursor-pointer shrink-0"
              (click)="copy($event)" [disabled]="!value">
        <mat-icon class="!text-base !leading-none translate-y-0.5"
                  [class]="copied ? 'icon-on' : 'text-muted'">
          {{ copied ? 'check' : 'content_copy' }}
        </mat-icon>
      </button>
    </span>
  `,
})
export class CopyValueComponent {
  @Input() value: string | null | undefined;
  @Input() display: string | null | undefined;

  copied = false;
  private timeout: ReturnType<typeof setTimeout> | null = null;

  constructor(private cdr: ChangeDetectorRef) {}

  copy(event: Event): void {
    event.stopPropagation();
    if (!this.value) return;
    navigator.clipboard.writeText(this.value).then(() => {
      this.copied = true;
      this.cdr.markForCheck();
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.copied = false;
        this.cdr.markForCheck();
      }, 1500);
    });
  }
}
